import axios, { type AxiosInstance } from "axios";
import { config } from "config/config";

/**
 * TODO: 기본 개발서버로 API 개발완료 시 제거해야함
 * 콘텐츠 분석 MSN axios 생성
 * 인사이트페이지용 API 노드서버 연결
 * @deprecated
 */
export const HttpNode: AxiosInstance = axios.create({
  baseURL: config.Url.NODE_SERVER_URL,
  headers: {
    // enctype: "multipart/form-data",
    "Cache-Control": "no-cache",
    "Content-Type": "application/json",
    Accept: "application/hal+json",
  },
  paramsSerializer: {
    encode: encodeURIComponent,
    indexes: null,
  },
});
